export const NoSubscriptions = () => (
		<div className="account-subscriptions--empty">
			<img src="img/sharp-big.svg" className="sharp" alt="alt"/>
			<div>No subscription found</div>
		</div>
)
